const SOURCE_HASH = /^#source-(finding_[A-Za-z0-9_-]+)-L\d+$/u;
const STORY_HASH = /^#(finding_[A-Za-z0-9_-]+)$/u;

export function findingIdFromSourceHash(hash: string): string | null {
  return SOURCE_HASH.exec(hash)?.[1] ?? null;
}

export function findingIdFromLocationHash(hash: string): string | null {
  return findingIdFromSourceHash(hash) ?? STORY_HASH.exec(hash)?.[1] ?? null;
}

export function findingStoryHash(findingId: string): string {
  return `#${findingId}`;
}

export function findingsHref(search: string, findingId: string | null): string {
  const query = search && !search.startsWith("?") ? `?${search}` : search;
  const path = `/findings${query}`;
  return findingId ? `${path}${findingStoryHash(findingId)}` : path;
}
